import { render } from "./NotAssignedModal.vue?vue&type=template&id=783ee889&scoped=true"
import script from "./NotAssignedModal.vue?vue&type=script&lang=js"
export * from "./NotAssignedModal.vue?vue&type=script&lang=js"

import "./NotAssignedModal.vue?vue&type=style&index=0&id=783ee889&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783ee889"]])

export default __exports__